module.exports = __webpack_public_path__ + "media/images/banner-assets/en/banner2-03643045e021186cfd4115101212fbe8.jpg";